import ArrowDownIcon from "assets/icons/Arrow-down.svg?react";
import React, { useState, FC, useEffect } from "react";
import { NavLink } from "react-router-dom";
import SearchBar from "./SearchBar";
import { menuItemsInteface } from "typings/navbarBreakerList";
interface Props {
  depthStep: number;
  depth: number;
  menuItem: menuItemsInteface;
  isSidebarOpen: boolean;
  searchText?: string;
  onSearchChange?: (text: string) => void;
}

const SidebarItem: FC<Props> = ({
  depthStep,
  depth,
  menuItem,
  isSidebarOpen,
  searchText,
  onSearchChange,
}) => {
  const [openDropDown, setOpenDropDown] = useState<boolean>(false);

  useEffect(() => {
    if (!isSidebarOpen) {
      setOpenDropDown(false); // Collapse dropdown when sidebar closes
    }
  }, [isSidebarOpen]);

  const dropDownHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setOpenDropDown((prev) => !prev);
  };

  const getNavLinkClassName = (isActive: boolean) => {
    const baseClasses = [];

    if (isActive) {
      if (menuItem.mainItem) {
        baseClasses.push(
          "bg-white border-l-[3px] border-solid border-interactive-blue text-interactive-blue fill-interactive-blue",
        );
      } else {
        baseClasses.push("bg-white text-interactive-blue");
      }
    }

    if (menuItem.mainItem) {
      baseClasses.push(
        "h-[48px] hover:cursor-pointer select-none w-full inline-flex justify-between items-center",
      );
      if (!isActive) {
        baseClasses.push("hover:hover-cursor");
      }
    } else {
      baseClasses.push(
        "flex items-center justify-starts bg-white justify-between",
      );
    }

    if (depth === 2 && !menuItem.mainItem) {
      baseClasses.push("h-6");
    }

    return baseClasses.join(" ");
  };

  const getContentClassName = () => {
    return menuItem.mainItem
      ? "justify-center"
      : "space-x-2 w-full justify-start";
  };

  const getIconClassName = () => {
    return menuItem.mainItem
      ? "flex items-center justify-center min-w-[52px] h-full text-3xl"
      : "text-lg";
  };

  const getTitleClassName = () => {
    const classes = [];

    if (!isSidebarOpen) {
      classes.push("scale-0");
    }

    if (depth === 0 || menuItem.mainItem) {
      classes.push(
        "h-full flex origin-left font-bold items-center justify-start duration-300 w-full",
      );
    } else {
      classes.push(
        "hover:text-interactive-blue flex items-center space-x-2 justify-start",
      );
    }

    if (menuItem.children && !menuItem.mainItem) {
      classes.push("font-bold");
    }

    if (depth === 1 && !menuItem.mainItem) {
      classes.push("text-clip font-bold truncate overflow-hidden w-full h-7");
    } else if (depth === 2 && !menuItem.mainItem) {
      classes.push("truncate overflow-hidden w-full");
    } else if (depth > 2) {
      classes.push("truncate overflow-hidden w-full");
    }

    return classes.join(" ");
  };

  const getArrowClassName = () => {
    const classes = [
      "flex select-none hover:cursor-pointer h-full items-center justify-center",
    ];

    if (menuItem.mainItem) {
      classes.push("min-w-[52px] min-h-[48px]");
    } else {
      classes.push("min-w-[26px] bg-pinks min-h-[26px] mr-4");
    }

    return classes.join(" ");
  };

  const getSubmenuClassName = () => {
    const classes = ["bg-white"];

    if (menuItem.id === "breakers") {
      classes.push("max-h-[18rem] overflow-y-auto overflow-x-hidden");
    }

    if (depth === 0) {
      classes.push("pl-11 pb-3");
    } else if (depth === 1) {
      classes.push("pl-4 pb-2");
    }

    return classes.join(" ");
  };
  const renderSubmenu = () => {
    if (!menuItem.children || !isSidebarOpen || !openDropDown) {
      return null;
    }

    return (
      <ul className={getSubmenuClassName()}>
        {menuItem.searchbar && isSidebarOpen && (
          <div className="pt-1 pb-2 pl-3 pr-3">
            <SearchBar
              searchText={searchText || ""}
              onSearchChange={onSearchChange!}
            />
          </div>
        )}

        {menuItem.children && menuItem.children.length > 0 ? (
          menuItem.children.map((subItem, index) => (
            <li key={`${subItem.id}${index}`}>
              <SidebarItem
                depth={depth + 1}
                depthStep={depthStep}
                menuItem={subItem}
                isSidebarOpen={isSidebarOpen}
              />
            </li>
          ))
        ) : (
          <li className="text-sm text-gray-500 px-4 py-2">
            No breakers found.
          </li>
        )}
      </ul>
    );
  };

  return (
    <div
      style={{ paddingLeft: depth >= 1 ? depth + depthStep : "" }}
      className="w-full"
    >
      <div className="flex flex-row">
        <NavLink
          to={menuItem.url}
          className={({ isActive }) => getNavLinkClassName(isActive)}
        >
          <div className={`${getContentClassName()} flex items-center`}>
            {menuItem.icon && (
              <span className={getIconClassName()}>{menuItem.icon}</span>
            )}
            <span className={getTitleClassName()}>
              {menuItem.title?.trim() || "N/A"}
            </span>
          </div>

          {menuItem.children && (
            <span onClick={dropDownHandler} className={getArrowClassName()}>
              <ArrowDownIcon
                className={`${openDropDown && "rotate-180 duration-75"}`}
                id="down-arrow"
              />
            </span>
          )}
        </NavLink>
      </div>
      {renderSubmenu()}
    </div>
  );
};

export default SidebarItem;
